import { filesFormats } from "../../../data/filesFormats";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { colors } from "../../../data/colors";
import { resumeText } from "../../../utils/resumeText";

export default function MiniatureFile({
  name,
  add = false,
  onClick,
}: {
  name: string;
  add: boolean;
  onClick: () => void;
}) {
  const parts = add ? name : name.split(".");
  const fileParts = Array.isArray(parts)
    ? [parts.slice(0, -1).join("."), parts.at(-1)]
    : false;

  const getFileType = () => {
    let fileStyle = {
      Icon: add ? AddBoxIcon : QuestionMarkIcon,
      color: colors.darkGrey,
    };
    if (
      Array.isArray(fileParts) &&
      typeof fileParts[0] === "string" &&
      typeof fileParts[1] === "string"
    ) {
      const imgKeys = Object.keys(filesFormats);
      for (const e of imgKeys) {
        if (
          filesFormats[e as keyof typeof filesFormats].list.includes(
            fileParts[1].toLowerCase()
          )
        ) {
          fileStyle.Icon = filesFormats[e as keyof typeof filesFormats].Icon;
          fileStyle.color = filesFormats[e as keyof typeof filesFormats].color;
          break;
        }
      }
    }
    return (
      <div
        style={{
          flex: 1,
          width: 70,
          backgroundColor: colors.white,
          borderRadius: 5,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <fileStyle.Icon style={{ fontSize: 60, color: fileStyle.color }} />
      </div>
    );
  };

  return (
    <div className="fileItem" onClick={onClick}>
      {getFileType()}
      <div style={{ marginTop: 5 }}>
        {Array.isArray(fileParts)
          ? typeof fileParts[0] === "string" &&
            typeof fileParts[1] === "string" &&
            fileParts[0].length > 20
            ? resumeText(fileParts[0]) + "." + fileParts[1]
            : name
          : name}
      </div>
    </div>
  );
}
